import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from '@fortawesome/free-solid-svg-icons';
import 'axios'
import 'jquery'
//import VueGoogleMaps from '@fawmi/vue-google-maps'
//import VueGoogleMaps from 'vue-google-maps-community-fork'


library.add(fas)
const vm = createApp(App)
vm.use(router).component('fa', FontAwesomeIcon)
vm.mount('#app')
